import { render } from "./FabricComponent.vue?vue&type=template&id=41aaf91a&scoped=true"
import script from "./FabricComponent.vue?vue&type=script&lang=js"
export * from "./FabricComponent.vue?vue&type=script&lang=js"

import "./FabricComponent.vue?vue&type=style&index=0&id=41aaf91a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aaf91a"]])

export default __exports__